import React from 'react';
import Box from '@mui/material/Box';
import {Button, CircularProgress, Typography} from "@mui/material";
import Paper from "@mui/material/Paper";
import {ResponsiveHeatMapCanvas} from '@nivo/heatmap'
import {ResponsiveBarCanvas} from '@nivo/bar'
import ApiCtrl from "../../svc/ApiCtrl";

import dayjs from 'dayjs';

export default function LeftView({result, path, setView, setYear,setNDay}) {


    const [loading, setLoading] = React.useState(true);


    const [period, setPeriod] = React.useState(null);
    const [tile, setTile] = React.useState(null);
    const [method, setMethod] = React.useState(null);

    const [dataHM, setdataHM] = React.useState(null);
    const [dataGraphe1, setDataGraphe1] = React.useState(null);
    const [dataGraphe2, setDataGraphe2] = React.useState(null);

    React.useEffect(() => {
        setTile({
            location: result.tile.location,
            name: result.tile.name,
            params: result.tile.params
        });
        setPeriod({
            min: result.periodMin,
            max: result.periodMax
        })
        setMethod({
            name: result.method.name,
            length: {
                min: result.method.lengthMin,
                max: result.method.lengthMax
            },
            workers: result.method.workers,
            threshold: result.method.threshold
        })

    }, [result])

    React.useEffect(() => {


        ApiCtrl.getHeatmap(path, (result) => {
            let data = []

            result.split("\n").forEach((line, i) => {
                if (i > 0) {
                    let item = line.split(",");
                    let listOfDates = []
                    let date = null;
                    item.forEach((it, j) => {
                        if (j < item.length - 2) {
                            listOfDates.push({x: j, y:  parseInt(it), realY: parseInt(it)})
                        } else {
                            date = it;
                        }
                    })
                    if (listOfDates.length > 0) {

                        data.push({id: date, data: listOfDates})
                    }
                }
            })
            data = data.sort().reverse()
            setdataHM(data);

        });

        ApiCtrl.getDays(path, (result) => {
            let days = []
            result.split("\n").forEach((item, i) => {
                if (i > 0 && item.length > 0) {
                    let s = item.split(",")
                    days.push({
                        "date": s[0],
                        "hot": parseFloat(s[1]),
                        "hotColor": "hsl(353,100%,55%)",
                        "cold": -parseFloat(s[2]),
                        "coldColor": "hsl(262, 70%, 50%)"
                    })
                }
            });
            setDataGraphe2(days);
        })

        ApiCtrl.getSeries(path, (result) => {
            let days = []
            result.split("\n").forEach((item, i) => {
                if (i > 0 && item.length > 0) {
                    let s = item.split(",")
                    days.push({
                        "date": s[0],
                        "hot": parseFloat(s[1]),
                        "hotColor": "hsl(353,100%,55%)",
                        "cold": parseFloat(s[2]),
                        "coldColor": "hsl(262, 70%, 50%)"
                    })
                }
            });
            setDataGraphe1(days);
        })
    }, [])

    React.useEffect(() => {
        if (dataGraphe2 && dataGraphe1 && dataHM && period && tile && method) {
            setLoading(false)
        }
    }, [dataGraphe2, dataGraphe1, dataHM, period, tile, method]);

    if (loading) {
        return (
            <Paper elevation={3}
                   sx={{
                       width: "48%", height: "95%", display: "flex",
                       alignItems: "center",
                       justifyContent: "center"
                   }}>

                <CircularProgress/>
            </Paper>)
    }

    function dateFromDay(year, day) {
        let date = new Date(year, 0); // initialize a date in `year-01-01`
        let d = new Date(date.setDate(day)); // add the number of days
        return dayjs(d).format("YYYY-MM-DD")
    }

    return (
        <Paper elevation={3} sx={{width: "48%", height: "98%", display: "flex", flexDirection: "column", p: 1}}>
            <Box sx={{ml: 5, display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex"}}>
                    <Button onClick={() => {
                        setView(null)
                    }}>
                        back
                    </Button>
                </Box>
                <Box sx={{display: "flex"}}>
                    <Typography variant="h4">Tile name:</Typography>
                    <Typography variant="h4" sx={{fontWeight: 'bold'}}>&nbsp;{tile.name.split("_")[0]} ({tile.params})</Typography>
                </Box>
                <Box sx={{display: "flex"}}>
                    <Typography variant="h6">Method info:</Typography>
                    {false && <Typography variant="h6" sx={{fontWeight: 'bold'}}>&nbsp;{method.name}</Typography>}
                    <Typography variant="h6">&nbsp;length : {method.length.min} - {method.length.max}</Typography>
                    <Typography variant="h6">,&nbsp;workers: {method.workers}</Typography>
                    <Typography variant="h6">,&nbsp;threshold: {method.threshold}</Typography>
                </Box>
                <Box sx={{display: "flex"}}>
                    <Typography>Period:</Typography>
                    <Typography>&nbsp;{period.min}</Typography>
                    <Typography>&nbsp;{period.max}</Typography>
                </Box>
            </Box>
            <Box sx={{width: "100%", height: "50%"}}>
                <ResponsiveHeatMapCanvas
                    data={dataHM}
                    margin={{top: 20, right: 80, bottom: 40, left: 80}}
                    valueFormat=">-.2s"
                    axisTop={null}
                    axisLeft={{
                        format: v => {

                            if (v % 5 === 0) {
                                return v + "-"
                            }
                            return " ";
                        },
                        tickSize: 2,
                        tickPadding: 1,
                        tickRotation: 0,
                        legend: '',
                        legendPosition: 'middle',
                        legendOffset: 40
                    }}
                    axisBottom={{
                        format: v => {

                            if (v % 15 === 0) {
                                return "-" + v
                            }
                            return " ";
                        },
                        tickSize: 2,
                        tickPadding: 1,
                        tickRotation: 90,
                        legend: '',
                        legendPosition: 'middle',
                        legendOffset: 36,
                        truncateTickAt: 0
                    }}

                    colors={{
                        type: 'diverging',
                        scheme: 'turbo',
                        divergeAt:0.4
                    }}
                    onClick={(e) => {
                        setYear(e.serieId);
                        setNDay(e.data.x)

                    }}
                    tooltip={(e) => {
                        return <Box sx={{backgroundColor: "#ffffff", borderColor: e.cell.borderColor, p: 1}}>
                            <Typography>Day: {dateFromDay(e.cell.serieId, e.cell.data.x)}</Typography>
                            <Typography>value: {e.cell.data.y}</Typography>
                        </Box>
                    }}
                    emptyColor="#555555"
                    borderWidth={0}
                    enableLabels={false}
                    legends={[
                        {
                            anchor: 'right',
                            translateX: 40,
                            translateY: 0,
                            length: 200,
                            thickness: 10,
                            direction: 'column',
                            tickPosition: 'after',
                            tickSize: 3,
                            tickSpacing: 4,
                            tickOverlap: false,
                            title: '',
                            titleAlign: 'start',
                            titleOffset: 4
                        }
                    ]}

                    annotations={[]}
                />
            </Box>
            <Box sx={{width: "100%", height: "30%", display: "flex", justifyContent: "space-between"}}>
                <Box sx={{width: "48%", height: "90%"}}>
                    <ResponsiveBarCanvas
                        data={dataGraphe1}
                        keys={[
                            'hot',
                            'cold'
                        ]}
                        indexBy="date"
                        margin={{top: 20, right: 0, bottom: 40, left: 60}}
                        pixelRatio={2}
                        padding={0.15}
                        innerPadding={0}
                        minValue="auto"
                        maxValue="auto"
                        groupMode="stacked"
                        layout="vertical"
                        reverse={false}
                        valueScale={{type: 'linear'}}
                        indexScale={{type: 'band', round: true}}
                        colors={["#FF0000", "#0000FF"]}

                        colorBy="id"
                        borderWidth={0}
                        borderRadius={0}
                        borderColor={{
                            from: 'color',
                            modifiers: [
                                [
                                    'darker',
                                    1.6
                                ]
                            ]
                        }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            format: v => {
                                let p = period.max - period.min;
                                if (p< 40) {
                                    if (v % 5 === 0) {
                                        return "-" + v
                                    }
                                }else{
                                    if (v % 10 === 0) {
                                        return "-" + v
                                    }
                                }
                                return " ";
                            },
                            tickSize: 2,
                            tickPadding: 1,
                            tickRotation: 90,
                            legend: '',
                            legendPosition: 'middle',
                            legendOffset: 36,
                            truncateTickAt: 0,

                        }}
                        axisLeft={{

                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: '',
                            legendPosition: 'middle',
                            legendOffset: -40,
                            truncateTickAt: 0
                        }}
                        enableGridX={false}
                        enableGridY={false}
                        enableLabel={false}
                        enableTotals={false}
                        totalsOffset={10}
                        labelSkipWidth={12}
                        labelSkipHeight={12}
                        labelTextColor={{
                            from: 'color',
                            modifiers: [
                                [
                                    'darker',
                                    1.6
                                ]
                            ]
                        }}
                        labelPosition="middle"
                        labelOffset={0}
                        isInteractive={true}
                        legends={[]}
                        onClick={(data, event) => {
                            setYear(data.data.date)
                            setNDay(1);
                        }}

                    />

                </Box>
                <Box sx={{width: "48%", height: "90%"}}>
                    <ResponsiveBarCanvas
                        data={dataGraphe2}
                        keys={[
                            'hot',
                            'cold'
                        ]}
                        indexBy="date"
                        margin={{top: 20, right: 0, bottom: 40, left: 60}}
                        pixelRatio={2}
                        padding={0.15}
                        innerPadding={0}
                        minValue="auto"
                        maxValue="auto"
                        groupMode="stacked"
                        layout="vertical"
                        reverse={false}
                        valueScale={{type: 'linear'}}
                        indexScale={{type: 'band', round: true}}
                        colors={["#FF0000", "#0000FF"]}

                        colorBy="id"
                        borderWidth={0}
                        borderRadius={0}
                        borderColor={{
                            from: 'color',
                            modifiers: [
                                [
                                    'darker',
                                    1.6
                                ]
                            ]
                        }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            format: v => {
                                let p = period.max - period.min;
                                if (p< 40) {
                                    if (v % 5 === 0) {
                                        return "-" + v
                                    }
                                }else{
                                    if (v % 10 === 0) {
                                        return "-" + v
                                    }
                                }
                                return " ";
                            },
                            tickSize: 2,
                            tickPadding: 1,
                            tickRotation: 90,
                            legend: '',
                            legendPosition: 'middle',
                            legendOffset: 36,
                            truncateTickAt: 0
                        }}
                        axisLeft={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: '',
                            legendPosition: 'middle',
                            legendOffset: -40,
                            truncateTickAt: 0
                        }}
                        enableGridX={false}
                        enableGridY={false}
                        enableLabel={false}
                        enableTotals={false}
                        totalsOffset={10}
                        labelSkipWidth={12}
                        labelSkipHeight={12}

                        labelTextColor={{
                            from: 'color',
                            modifiers: [
                                [
                                    'darker',
                                    1.6
                                ]
                            ]
                        }}
                        labelPosition="middle"
                        labelOffset={0}

                        isInteractive={true}
                        legends={[]}
onMouseEnter={(data, event) => {
  console.log(event)
}}
                        onClick={(data, event) => {
                            setYear(data.data.date)
                            setNDay(1);
                        }}
                    />
                </Box>
            </Box>
            <Box sx={{width: "100%", display: "flex", justifyContent: "space-between"}}>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "48%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    {false && <Typography variant={"h6"}>
                        Unique grid cells per year
                    </Typography>}
                    <Typography variant={"h7"} sx={{"width": "80%"}}>
                        Histogram of the number of grid cells where a burst commences in the year.
                    </Typography>

                </Box>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "48%",
                    alignItems: "center",
                    textAlign: "center"
                }}>
                    {false && <Typography variant={"h6"}>
                        Burst days per year
                    </Typography>}
                    <Typography variant={"h7"} sx={{"width": "80%"}}>
                        Burst days per year, Histogram of the aggregated number of days belonging to bursts per
                        year.
                    </Typography>

                </Box>

            </Box>
        </Paper>
    )
}
